import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../../../../../core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-property-tags',
  templateUrl: './property-tags.component.html',
  styleUrls: ['./property-tags.component.scss']
})
export class PropertyTagsComponent implements OnInit {
  @Input() property: any;
  @Input() project: any;

  indoor = [];
  outdoor = [];
  energy = [];
  publicFacilities = [];
  propertyPromotionTags = [];
  selectedTagIdArray = [];

  constructor(private httpService: HttpService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    console.log(this.property);
    this.httpService.getAllTagsByUser().subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.indoor = res.data.filter(m => m.type === 1);
        this.outdoor = res.data.filter(m => m.type === 2);
        this.energy = res.data.filter(m => m.type === 3);
        this.publicFacilities = res.data.filter(m => m.type === 4);
        this.propertyPromotionTags = res.data.filter(m => m.type === 5);
        if (this.property.tags) {
          this.property.tags.map((tag) => {
            this.selectedTagIdArray.push(tag.id);
          });
          // console.log(this.selectedTagIdArray);
        }
      }
    });
  }

  submit() {
    const fd = new FormData();
    if (this.selectedTagIdArray.length > 0) {
      fd.append('tagIds', this.selectedTagIdArray.toString());
    } else {
      return;
    }

    this.httpService.updateProperty(this.property.id, fd).subscribe((r: any) => {
      console.log(r);
      if (r.code === 1) {
          this.toastrService.success('Property has been updated');
      } else {
        this.toastrService.error('Failed to update property.');
        // this.isCreating = false;
        // this.cdr.detectChanges();
      }
    });


  }

  isCheckBoxSelected(productId: number) {
    return this.selectedTagIdArray.includes(productId);
  }

  select(event: MatCheckboxChange, productId) {
    console.log(this.selectedTagIdArray);
    if (event.checked) {
      this.selectedTagIdArray.push(productId);
      // if (this.selectedProductIdArray.length >= 2) {
      //     this.canCombine = true;
      // }
    } else {
      const index = this.selectedTagIdArray.indexOf(productId);
      this.selectedTagIdArray.splice(index, 1);
      // if (this.selectedProductIdArray.length < 2) {
      //     this.canCombine = false;
      // }
    }
    console.log(this.selectedTagIdArray);
  }

}
